import React from 'react';

export const ACErrorBoundary = ({
  error,
  isApiError = false,
  isExpired = false,
}: {
  error: unknown;
  isApiError?: boolean;
  isExpired?: boolean;
}) => {
  const errorMessage =
    isApiError && typeof error === 'string' ? error : 'Oops, it seems like something went wrong.';

  return (
    <React.Fragment>
      {!isExpired && (
        <div className="bg-[#372DB1] text-white rounded-lg p-4 text-center mt-2">
          <div className="text-lg">{errorMessage}</div>
        </div>
      )}
    </React.Fragment>
  );
};
